import {
  LOGIN_USER,
  LOGOUT_USER,
} from '../actions';

export const loginUser = (adminId) => ({
  type: LOGIN_USER,
  adminId: adminId
});

export const logoutUser = () => ({
  type: LOGOUT_USER,
});


